module.exports = {
    localStorageUser: "protonBeamUser",
    oauthUrl: 'https://login.csns.ihep.ac.cn/oauth2/authorize',
    tokenUrl: 'https://login.csns.ihep.ac.cn/oauth2/token',
    logoutUrl: 'https://login.csns.ihep.ac.cn/logout',


    // Development at home
    // homePage: 'http://localhost:8080',
    // serverPath: "http://localhost:3000/api",
    // clientID: '81622',
    // clientSecret: 'aoJp1DIgDEwQ5bU8ioU5tpwh9XLFIfoz',
    // redirectUrl: 'http://10.1.44.253:8080/oauth/redirect',


    // // Development at office
    // homePage: 'http://10.1.44.253:8080',
    // serverPath: "http://10.1.44.253:3000/api",
    // clientID: '81622',
    // clientSecret: 'aoJp1DIgDEwQ5bU8ioU5tpwh9XLFIfoz',
    // redirectUrl: 'http://10.1.44.253:8080/oauth/redirect',


    // // Production
    homePage: 'https://apep.csns.ihep.ac.cn',
    serverPath: "https://apep.csns.ihep.ac.cn:3000/api",
    clientID: '48985',
    clientSecret: 'xvZ0B3iGczu7g64XOubXQbb1vp5W5C0t',
    redirectUrl: 'https://apep.csns.ihep.ac.cn/oauth/redirect',   
}